export function parseRequestLimit(draft, currentLimit) {
    const value = Number(draft.trim().replace(",", "."));
    if (!/^\d*(?:[.,]\d{1,2})?$/.test(draft.trim()) ||
        !Number.isFinite(value) ||
        value <= 0 ||
        !Number.isSafeInteger(Math.round(value * 100))) {
        throw new Error("Введите положительную сумму, не более двух знаков после запятой.");
    }
    if (currentLimit !== undefined && value <= currentLimit) {
        throw new Error("Новый лимит должен быть больше текущего.");
    }
    return value;
}
export const requestLimitModelKey = (provider, model) => JSON.stringify([provider, model]);
export function requestLimitModelOptions(prices, policies, selected = []) {
    const options = new Map();
    for (const [provider, value] of Object.entries(prices?.providers ?? {})) {
        // Policies match upstream models, not CoreInfra routing aliases.
        if (provider === "coreinfra")
            continue;
        for (const [model, price] of Object.entries(value.models)) {
            if (model === "*" || model === "default")
                continue;
            const key = requestLimitModelKey(provider, model);
            options.set(key, {
                key,
                provider,
                model,
                label: price.display_name || model,
            });
        }
    }
    // Keep configured models visible even if they have left the catalog.
    for (const policy of policies) {
        const key = requestLimitModelKey(policy.provider, policy.model);
        if (!options.has(key)) {
            options.set(key, {
                key,
                provider: policy.provider,
                model: policy.model,
                label: policy.display_name || policy.model,
            });
        }
    }
    // Retain unsaved selections if the catalog changes while the picker is open.
    for (const option of selected) {
        if (!options.has(option.key))
            options.set(option.key, option);
    }
    return [...options.values()].sort((a, b) => a.provider.localeCompare(b.provider) ||
        a.label.localeCompare(b.label) ||
        a.model.localeCompare(b.model));
}
